// Shared debug/runtime helpers.
export function isDevEnv(): boolean {
  const metaEnv = typeof import.meta !== 'undefined'
    ? import.meta.env
    : undefined;
  if (metaEnv?.DEV === true) return true;
  if (typeof process !== 'undefined') {
    if (process.env?.NODE_ENV === 'development') return true;
    if (process.env?.VITEST) return true;
  }
  return false;
}
